import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { styles } from './ModifyChangeRequest/styles';

export const REQUISITION_POSITIONS_NOTE = 'Note: This changes will be applicable for all positions in the requisition.';

export const RequisitionPositionsNote = ({ sx = {}, align = 'left', variant = 'caption' }) => (
    <Typography
        sx={{
            ...styles.text,
            display: 'block',
            width: '100%',
            color: 'error.main',
            fontWeight: 700,
            textAlign: align,
            ...sx,
        }}
        variant={variant}
    >
        {REQUISITION_POSITIONS_NOTE}
    </Typography>
);

export const getPositionsInRequisition = (source) => {
    if (!source) return null;

    const positions =
        source.positions_in_requisition ??
        source.positionsInRequisition ??
        source.position?.positions_in_requisition ??
        source.position?.positionsInRequisition ??
        source.changeRequest?.positions_in_requisition ??
        source.changeRequest?.positionsInRequisition ??
        source.changeRequest?.position?.positions_in_requisition ??
        source.changeRequest?.position?.positionsInRequisition;

    if (!positions) return null;
    if (Array.isArray(positions) && positions.length === 0) return null;
    if (typeof positions === 'object' && !Array.isArray(positions) && Object.keys(positions).length === 0) {
        return null;
    }

    return positions;
};

export const getPositionCodesFromRequisition = (positions) => {
    if (!positions) return [];

    const list = Array.isArray(positions) ? positions : Object.values(positions);

    return list
        .map((item) => {
            if (typeof item === 'string') return item;
            return item?.positionCode ?? item?.position_code ?? item?.position?.positionCode ?? item?.code ?? null;
        })
        .filter(Boolean);
};

const PositionCodesDisplay = ({
    positionsInRequisition,
    fallbackCode,
    showNote = true,
    align = 'left',
    noteVariant = 'caption',
}) => {
    const codes = getPositionCodesFromRequisition(positionsInRequisition);

    if (codes.length > 0) {
        return (
            <Box sx={{ mt: 0.5, width: '100%' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        justifyContent: align === 'center' ? 'center' : 'flex-start',
                    }}
                >
                    {codes.map((code) => (
                        <Chip key={code} label={code} sx={{ backgroundColor: '#d3edff' }} />
                    ))}
                </Box>
                {showNote ? <RequisitionPositionsNote align={align} variant={noteVariant} sx={{ mt: 1 }} /> : null}
            </Box>
        );
    }

    return (
        <Typography sx={styles.text} color="textPrimary" variant="body2">
            {fallbackCode || '-'}
        </Typography>
    );
};

export default PositionCodesDisplay;
